import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ContactSales } from "Views/Public/Home/ContactSales";
import useAuth from "Context/useAuth";
import { paths } from "Constant/paths";
import { SOCIAL_LINKS } from "Constant/constants";

export const PublicHeader = () => {
  const { t, i18n } = useTranslation();
  const { contactSalesModal, toggleContactSalesModal } = useAuth();

  const [language, setLanguage] = useState("en");

  // On Chage
  const handleChangeLanuage = (e) => {
    setLanguage(e.target.value);
    i18n.changeLanguage(e.target.value);
    localStorage.setItem("language", e.target.value);
  };

  useEffect(() => {
    const selectLanguage = localStorage.getItem("language");
    if (selectLanguage) {
      setLanguage(selectLanguage);
    }
  }, [localStorage]);

  return (
    <>
      <header className="sticky-top header-web border-bottom">
        <nav className="navbar navbar-expand-md bg-white">
          <div className="container-xl">
            <Link className="navbar-brand" to={paths.root}>
              <img
                src="/assets/images/pluto-logo.svg"
                alt="PlutoEdu Logo"
                width={180}
                height={47}
              />
            </Link>
            <div className="ms-auto d-flex gap-1 d-md-none">
              <Link to={paths.registration} className="btn btn-outline-primary">
                {t("common.button.signUp")}
              </Link>
              <Link to={paths.login} className="btn btn-theme">
                Sign In
              </Link>
            </div>
            <button
              className="navbar-toggler pe-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse column-gap-3 px-3 bg-white"
              id="navbarNav"
            >
              <ul className="navbar-nav column-gap-3 ms-auto">
                {/* <li className="nav-item">
                  <Link className="nav-link" to={paths.jobs}>
                    {t("common.jobs")}
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link to={paths.careers} className="nav-link">
                    {t("common.careers")}
                  </Link>
                </li>
                <li className="nav-item">
                  <a
                    href={SOCIAL_LINKS.blog}
                    className="nav-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Blog
                  </a>
                </li>
                <li className="nav-item">
                  <button
                    className="nav-link"
                    onClick={toggleContactSalesModal}
                  >
                    {t("common.contactUs")}
                  </button>
                </li>
              </ul>
              <div className="d-md-flex gap-2 d-none">
                <Link
                  to={paths.registration}
                  className="btn btn-lg-theme btn-outline-primary"
                >
                  {t("common.button.signUp")}
                </Link>
                <Link to={paths.login} className="btn btn-lg-theme btn-primary">
                  {t("common.button.signIn")}
                </Link>

                {/* <div className="language ms-auto">
                    <select
                      className="language-input"
                      id="language"
                      value={language}
                      onChange={handleChangeLanuage}
                    >
                      <option value="en">English</option>
                      <option value="ar">Arabic</option>
                    </select>
                  </div> */}
              </div>
            </div>
          </div>
        </nav>

        {contactSalesModal && (
          <ContactSales
            show={contactSalesModal}
            toggle={toggleContactSalesModal}
          />
        )}
      </header>
    </>
  );
};
